var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { BigSize } from './BigSize';
import Default from './Default';
import { Simple } from './Simple';
/**
 * You can use VisitorCounter for recording the number of hits of users who visit the your site.
 *
 * @props theme: You can dramatically change the UI of the VisitorCounter by choosing one of the following themes: `'default' | 'big-size' | 'simple'`. (default: 'default')
 * @props title: Hit title text used only on `'default'` and `'big-size'` themes. (default: 'hit')
 * @props todayVisitor: Number of today's visitors. (default: 0)
 * @props todayVisitorColor: todayVisitor color style. (default: 'red')
 * @props totalVisitor: Number of total visitors. (default: 123)
 * @props totalVisitorColor: totalVisitor color style. (default: 'red')
 * @props todayTitle: Title of today's the number of visitors used only on `'big-size'` and `'simple'` themes. (default: 'today')
 * @props todayTitleColor: todayTitle color style. (default: 'black')
 * @props totalTitle: Title of total's the number of visitors used only on `'big-size'` and `'simple'` themes. (default: 'total')
 * @props totalTitleColor: totalTitle color style. (default: 'black')
 * @props backgroundColor: Background color of todayTitle. (default: '#91c230c4')
 * @props size: Font size of all text used in VisitorCounter Component (default: '14px') (unit: px)
 */
var VisitorCounter = function (props) {
    var theme = props.theme;
    switch (theme) {
        case 'default':
            return _jsx(Default, __assign({}, props));
        case 'big-size':
            return _jsx(BigSize, __assign({}, props));
        case 'simple':
            return _jsx(Simple, __assign({}, props));
        default:
            return _jsx(Default, __assign({}, props));
    }
};
export default VisitorCounter;
VisitorCounter.defaultProps = {
    title: 'hits',
    todayVisitor: 0,
    totalVisitor: 123,
    todayTitle: 'today',
    todayTitleColor: 'black',
    totalTitle: 'total',
    totalTitleColor: 'black',
};
